import React, { useContext, useState, useEffect } from 'react'
import Layout from '@/product/components/templates/Layout'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import '../Dashboard/Dashboard.css'
import './invoice.css'
import CustomTable from '@/product/components/molecules/CustomTable'
import InvoiceContext from '@/product/context/invoice/invoiceContext'
import CartContext from '@/product/context/cart/cartContext'

import CustomSearch from '@/product/components/molecules/CustomSearch'
import ReportContext from '@/product/context/report/reportContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import InvoiceView from './view'
import { Button } from '@mui/material'
import { useFormik } from 'formik'
import PaymentManage from '@/views/Payment/PaymentManage'
import { mapData } from '@/product/common/components'
import RefundInvoice from '@/custom/components/organisms/RefundInvoice'
import CustomCommonContext from '@/custom/context/common/commonContext'
import * as Yup from 'yup'
import AuthContext from '@/product/context/auth/authContext'
import { handleRedirectInternal } from '@/custom/common/components'
import SettingContext from '@/product/context/setting/settingContext'
import { useHistory, withRouter } from 'react-router-dom'

const Invoice = (props) => {
    const reportContext = useContext(ReportContext)
    const authContext = useContext(AuthContext)
    const invoiceContext = useContext(InvoiceContext)
    const cartContext = useContext(CartContext)
    const settingcontext = useContext(SettingContext)
    const [isLoading, setIsLoading] = useState(true)
    const { getAllExportDownload } = reportContext
    const { alldata_all_dropdown, allLocations } =
        useContext(CustomCommonContext)

    const {
        all_invoices,
        getAllInvoices,
        changeProductStatus,
        responseStatus: responseStatusInvoice,
    } = invoiceContext
    const { responseStatus: responseStatusCart } = cartContext
    const {
        searchTableAction,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext
    const {
        user,
        responseStatus: responseStatusAuth,
        clearResponse: clearResponseAuth,
        logout,
    } = authContext

    const history = useHistory()
    let action = props.match.params.action
    const onClickInvoiceEdit = (id, secondaryID, type) => {
        handleRedirectInternal(
            history,
            `invoice/view/${action}/${id}/${secondaryID}`
        )
    }

    const [changeStatus, setChangeStatus] = React.useState(false)
    const [invoiceNotesStatus, setInvoiceNotesStatus] = React.useState(false)
    const [disable, setDisable] = React.useState(false)

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
        sid: 0,
    })

    const [manageCredits, setManageCredits] = useState({
        popup: false,
        status: 'new',
        id: 0,
        sid: 0,
    })

    const onClickPreview = (id, type) => {
        window.open(
            `${process.env.REACT_APP_FRONTEND_URL}productView/${id}`,
            '_blank',
            'noopener,noreferrer'
        )
    }

    const [manageRefund, setManageRefund] = useState({
        popup: false,
        status: 'new',
        data: null,
    })

    const toggleFullScreenPopup = (popup, status, id, sid) => {
        if (popup && status != '') {
            handleRedirectInternal(
                history,
                `invoice/view/${action}/${id}/${sid}`
            )
            // setManage({ popup, status, id, sid })
        } else {
            setManage({ popup, status: 'new', id: 0, sid: 0 })
        }
    }

    const toggleCreditsPopup = (popup, status, id, sid) => {
        if (popup) {
            setManageCredits({ popup, status, id, sid })
        } else {
            setManageCredits({ popup, status: 'new', id: 0, sid: 0 })
        }
    }

    const toggleRefundPopup = (popup, status, data) => {
        if (popup) {
            setManageRefund({ popup, status, data })
        } else {
            setManageRefund({
                popup,
                status: status ? status : 'new',
                data: null,
            })
        }
    }

    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const toggleInvoiceModal = () => {
        setInvoiceNotesStatus(!invoiceNotesStatus)
        formikNotesSelection.resetForm()
    }

    const [tableBody, setTableBody] = useState([])

    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: global?.zb_custom_table_limit || 60,
            order: '',
            orderby: '',
            include_return: true,
            filters: {
                action: {
                    value: action ? action.toString() : null,
                    type: 'in',
                    field: 'b.paid',
                },
                active: {
                    value: 2,
                    type: 'in',
                    field: 'b.active',
                },
                searchterm: {
                    value: '',
                    type: 'like',
                    field: 'b.common_invoice',
                },
                fromdate: {
                    value: '',
                    type: 'dategreaterequal',
                    field: 'b.date_added',
                },
                todate: {
                    value: '',
                    type: 'datesmallerequal',
                    field: 'b.date_added',
                },
                first_name: {
                    value: '',
                    type: 'like',
                    field: 'u.first_name',
                },
                last_name: {
                    value: '',
                    type: 'like',
                    field: 'u.last_name',
                },
                phone: {
                    value: '',
                    type: 'like',
                    field: 'u.phone',
                },
                address1: {
                    value: '',
                    type: 'like',
                    field: 'u.address1',
                },
                email: {
                    value: '',
                    type: 'like',
                    field: 'u.email',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getAllInvoices(values)
        },
    })

    const formikSelection = useFormik({
        initialValues: {
            action: '',
            project_id: '',
            auction_id: '',
            notes: '',
        },
        validationSchema: Yup.object({
            notes: Yup.string().when('action', {
                is: 'cancel',
                then: Yup.string().required('Required!'),
            }),
        }),
        onSubmit: (values) => {
            if (
                values.action === 'paid' ||
                values.action === 'draft' ||
                values.action === 'cancel'
            ) {
                changeProductStatus(values)
            } else {
                assignAuctionLot(values)
            }
        },
    })

    const formikNotesSelection = useFormik({
        initialValues: {
            id: 0,
            user_id: user?.emp_id ? user.emp_id : 0,
            notes: '',
            active: 1,
            table: 'user_invoice_notes',
            common_invocie: '',
        },
        validationSchema: Yup.object({
            notes: Yup.string().required('Required'),
        }),
        onSubmit: (values) => {
            values.user_id = user?.emp_id
            setDisable(true)
            searchTableAction(values)
            console.log(values, 'checkValues')
        },
    })

    useEffect(() => {
        if (all_invoices) {
            setTableBody(
                all_invoices.records.length ? all_invoices.records : []
            )
            setIsLoading(false)
        }
    }, [all_invoices])

    useEffect(() => {
        if (responseStatusSetting) {
            if (
                responseStatusSetting.from === 'CommunicationSearchTable' &&
                responseStatusSetting.status === 'success'
            ) {
                setInvoiceNotesStatus(false)
                formikNotesSelection.resetForm()
                getAllInvoices(formik.values)
            }
            setDisable(false)
        }
    }, [responseStatusSetting])

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.filters.action.value = action
        formik.values.page = 1
        formik.values.filters.fromdate.value = ''
        formik.values.filters.todate.value = ''
        formik.values.filters.searchterm.value = ''
        if (action === 'all') {
            formik.values.filters.active.type = 'all'
        } else {
            formik.values.filters.active.type =
                action === 'cancel' ? 'in' : 'notin'
            formik.values.filters.active.value = 2
        }

        getAllInvoices(formik.values)
        /*  return () => {
            setTableBody([])
        }*/
    }, [action])

    useEffect(() => {
        if (manageRefund.status === 'refresh') {
            getAllInvoices(formik.values)
        }
    }, [manageRefund])

    useEffect(() => {
        console.log('formikSelection.values', formikSelection.values)
    }, [formikSelection.values])

    const onClickView = (id, sid, type) => {
        toggleFullScreenPopup(true, type, id, sid)
    }
    const onClickViewNew = (id, sid, type) => {
        window.open(
            `${location.origin}/invoice/view/${action}/${id}/${sid}`,
            '_blank',
            'noopener,noreferrer'
        )
        // toggleFullScreenPopup(true, type, id, sid)
    }
    const onEditNotes = (id, secondaryID) => {
        console.log(id, secondaryID, 'ghiyu')
        formikNotesSelection.values.common_invoice = id
        formikNotesSelection.values.id = secondaryID ? secondaryID : 0
        toggleInvoiceModal(true)
    }

    const onClickEdit = (id, secondaryID, type) => {
        toggleCreditsPopup(true, type, id, secondaryID)
    }

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.project_id = data
        if (action === 'paid' || action === 'draft' || action === 'cancel') {
            setChangeStatus(true)
        }
    }

    const getMultipleAction = () => {
        let actionPush = [
            {
                buttonType: 'visibility',
                clickType: 'view',
                onclick: onClickView,
                clickID: 'common_invoice',
                secondaryClickID: 'user_id',
                tooltipTitle: 'View invoice',
            },
            // {
            //     buttonType: 'description',
            //     clickType: 'view',
            //     onclick: onEditNotes,
            //     clickID: 'common_invoice',
            //     secondaryClickID: 'user_invoice_notes_id',
            //     tooltipTitle: 'Add invoice notes',
            // },
        ]
        // if (action === 'unpaid' || action === 'draft') {
        //     actionPush.push({
        //         buttonType: 'monetization_on',
        //         clickType: 'edit',
        //         onclick: onClickEdit,
        //         clickID: 'common_invoice',
        //         secondaryClickID: 'user_id',
        //         tooltipTitle: 'Make payment',
        //     })
        // }
        // if (action === 'paid') {
        //     actionPush.push({
        //         buttonType: 'undo',
        //         clickType: 'edit',
        //         onclick: onClickRefundInvoice,
        //         tooltipTitle: 'Refund Invoice',
        //         clickID: 'common_invoice',
        //         secondaryClickID: 'user_id',
        //     })
        // }
        return actionPush
    }

    const onClickRefundInvoice = (id, secondaryID) => {
        toggleRefundPopup(true, 'view', {
            id,
            user_id: secondaryID,
            projects_shipping: 'shipEngine',
        })
    }

    const tableValues = [
        {
            field: 'projects_id',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Lot #',
            filterable: true,
            filterField: 'p.id',
        },
        {
            field: 'user_id',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Bidder #',
            filterable: true,
            filterField: 'u.id',
        },
        {
            field: 'users_first_name',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'User First Name',
            filterable: true,
            filterField: 'u.first_name',
        },
        {
            field: 'users_last_name',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'User Last Name',
            filterable: true,
            filterField: 'u.last_name',
        },
        {
            field: 'users_phone',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'User Phone',
            filterable: true,
            filterField: 'u.phone',
        },
        {
            field: 'users_address1',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'User Address',
            filterable: true,
            filterField: 'u.address1',
        },
        {
            field: 'common_invoice',
            type: 'hyperlink',
            clickID: 'common_invoice',
            secondaryClickID: 'user_id',
            onclick: onClickViewNew,
            clickType: 'view',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Invoice #',
            filterable: true,
            filterField: 'b.common_invoice',
        },
        {
            field: 'amount',
            type: 'price',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Subtotal',
            filterable: true,
            filterField: 'b.amount',
        },
        {
            field: 'total_premium',
            type: 'price',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'ZB Fee',
            filterable: true,
            filterField: 'b.total_premium',
        },
        {
            field: 'total_tax',
            type: 'price',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Tax Amount',
            filterable: true,
            filterField: 'b.total_tax',
        },
        {
            field: 'total_amount',
            type: 'price',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Total Amount',
            filterable: true,
            filterField: 'b.total_amount',
        },
        {
            field: 'total_invoice',
            type: 'price',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Total Invoice Amount',
            filterable: true,
            filterField: 'b.total_invoice',
        },
    ]

    // if (action === 'paid') {
    //     tableValues.push({
    //         field: 'total_invoice',
    //         type: 'price',
    //         firstChild: false,
    //         sort: true,
    //         disablePadding: false,
    //         label: 'Amount',
    //     })
    // } else {
    //     tableValues.push({
    //         field: 'total_amount',
    //         type: 'price',
    //         firstChild: false,
    //         sort: true,
    //         disablePadding: false,
    //         label: 'Amount',
    //     })
    // }

    tableValues.push(
        {
            field: 'user_invoice_notes_notes',
            type: '',
            firstChild: false,
            disablePadding: false,
            label: 'Notes',
        },
        {
            field: 'projects_title',
            type: 'hyperlink',
            clickID: 'projects_id',
            onclick: onClickPreview,
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Inventory Title',
            filterable: true,
            filterField: 'p.title',
        },
        {
            field: 'custom_projects_manufacturer',
            type: 'singleSelect',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Manufacturer',
            filterable: true,
            valueOptions: alldata_all_dropdown
                .filter(
                    (data) => data.level == 0 && data.variable == 'manufacturer'
                )
                .map((data) => {
                    let valueChanged = {}
                    console.log(data, 'ghghh')
                    valueChanged.label = data.description
                    valueChanged.value = data.id.toString()
                    console.log(valueChanged, 'vhnjnj')
                    return valueChanged
                }),
            filterField: 'it.manufacturer',
        },
        {
            field: 'custom_projects_location',
            type: 'singleSelect',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Location',
            filterable: true,
            valueOptions: allLocations.map((data) => {
                let valueChanged = {}
                console.log(data, 'ghghh')
                valueChanged.label = data.name
                valueChanged.value = data.id.toString()
                console.log(valueChanged, 'vhnjnj')
                return valueChanged
            }),
            filterField: 'it.location',
        },
        {
            field: 'custom_projects_brand',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Brand',
            filterable: true,
            filterField: 'it.brand',
        },
        {
            field: 'custom_projects_bin_location',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Bin Location',
            filterable: true,
            filterField: 'it.bin_location',
        },
        {
            field: 'total_items',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Items',
        }
    )

    // if (action === 'unpaid' || action === 'draft') {
    //     tableValues.push({
    //         field: 'paid_amount',
    //         type: 'price',
    //         firstChild: false,
    //         disablePadding: false,
    //         label: 'Paid Amount',
    //     })
    // }

    tableValues.push(
        {
            field: 'users_email',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Email',
            filterable: true,
            filterField: 'u.email',
        },
        //date_added
        {
            field: 'date_added',
            type: 'date',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Created Date',
        }
    )

    if (action === 'cancel') {
        tableValues.push({
            field: 'returned_date',
            type: 'date',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Cancel Date',
        })
        tableValues.push({
            field: 'emp_name',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Employee name',
        })
    }

    if (action === 'paid') {
        tableValues.push({
            field: 'paid_date',
            type: 'date',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Paid Date',
        })
    }

    tableValues.push({
        field: 'action',
        type: 'button',
        sort: false,
        firstChild: false,
        clickID: 'common_invoice',
        disablePadding: false,
        label: 'Action',
        isMultiple: getMultipleAction(),
    })

    const tableActions = []

    // if (action === 'paid') {
    //     tableActions.push({
    //         label: 'Move to Unpaid',
    //         icon: <span className="material-icons">low_priority</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'draft',
    //     })
    // } else if (action === 'unpaid' || action === 'draft') {
    //     tableActions.push({
    //         label: 'Move to Paid',
    //         icon: <span className="material-icons">low_priority</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'paid',
    //     })
    //     tableActions.push({
    //         label: 'Cancel Invoice',
    //         icon: <span className="material-icons">block</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'cancel',
    //     })
    // } else {
    //     tableActions.push(
    //         {
    //             label: 'Move to Unpaid',
    //             icon: <span className="material-icons">low_priority</span>,
    //             onclick: onSelectMultiProducts,
    //             type: 'draft',
    //         },
    //         {
    //             label: 'Move to Paid',
    //             icon: <span className="material-icons">low_priority</span>,
    //             onclick: onSelectMultiProducts,
    //             type: 'paid',
    //         }
    //     )
    // }

    const searchInfo = {
        formik: formik,
        data: [
            {
                label: 'Invoice Number',
                placeholder: 'Enter invoice number',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'searchterm',
                filter: true,
            },
            {
                label: 'Created From Date',
                placeholder: 'Date Ending from',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'date',
                name: 'fromdate',
                filter: true,
            },
            {
                label: 'Created To Date',
                placeholder: 'Date Ending To',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'date',
                name: 'todate',
                filter: true,
            },
            {
                label: 'User First Name',
                placeholder: 'Enter First Name',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'first_name',
                filter: true,
            },
            {
                label: 'User Last Name',
                placeholder: 'Enter Last Name',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'last_name',
                filter: true,
            },
            // {
            //     label: 'User Last Name',
            //     placeholder: 'Enter Last Name',
            //     class: 'col-md-4 col-sm-6 col-12',
            //     type: 'text',
            //     name: 'last_name',
            //     filter: true,
            // },
            {
                label: 'User Phone',
                placeholder: 'Enter Phone',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'phone',
                filter: true,
            },
            {
                label: 'User Address',
                placeholder: 'Enter Address',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'address1',
                filter: true,
            },
        ],
    }

    const reasonForCancelInvoice = [
        {
            label: 'Reason *',
            name: 'notes',
            type: 'text',
            placeholder: 'Reason for cancellation',
            formik: formikSelection,
        },
    ]

    const invoiceNotes = [
        {
            label: 'Notes',
            name: 'notes',
            type: 'textarea',
            placeholder: 'Enter your invoice notes',
            formik: formikNotesSelection,
        },
    ]
    const resetForm = () => {
        formik.values.filters.fromdate.value = ''
        formik.values.filters.todate.value = ''
        formik.values.filters.searchterm.value = ''
    }

    useEffect(() => {
        if (responseStatusInvoice) {
            if (
                responseStatusInvoice.status === 'success' &&
                responseStatusInvoice.from === 'productchange'
            ) {
                setChangeStatus(false)
                getAllInvoices(formik.values)
            }
        }
    }, [responseStatusInvoice])

    useEffect(() => {
        if (responseStatusCart) {
            if (responseStatusCart.status === 'success') {
                if (responseStatusCart.from === 'payCartWallet') {
                    toggleCreditsPopup(false)
                    getAllInvoices(formik.values)
                } else if (responseStatusCart.from === 'payCartOffline') {
                    toggleCreditsPopup(false)
                    getAllInvoices(formik.values)
                }
            }
        }
    }, [responseStatusCart])

    return (
        <Layout>
            <div className="dashboard invoice">
                <CustomSearch
                    searchInfo={searchInfo}
                    formik={formik}
                    advFilters={global?.advFilters ? global?.advFilters : false}
                    resetForm={resetForm}
                />
                {user?.emp_type === 'super_admin' ||
                user?.emp_type === 'admin' ? (
                    <div className="d-flex justify-content-end">
                        <Button
                            id="invoice_report"
                            onClick={() =>
                                getAllExportDownload({
                                    action: 'export',
                                    order: 'asc',
                                    orderby: '',
                                    search: 'all',
                                    report: `${action}_invoice_management`,
                                })
                            }
                        >
                            <span className="material-icons">get_app</span>
                            Export All Data
                        </Button>
                    </div>
                ) : null}

                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={all_invoices}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={getAllInvoices}
                />
            </div>
            {/* <InvoiceView data={manage} function={toggleFullScreenPopup} /> */}
            <PaymentManage
                data={manageCredits}
                from={props.from || ''}
                paymentMode={props.paymentMode}
                full_payment={props.full_payment}
                function={toggleCreditsPopup}
                taxLabel={'Sales Tax'}
            />
            <RefundInvoice data={manageRefund} function={toggleRefundPopup} />
            <CustomDialog
                title={'Change invoice status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>Are you sure you want to change the status</h5>
                {formikSelection.values.action === 'cancel' &&
                    mapData(reasonForCancelInvoice)}
                <div className="actionWrapper">
                    <Button
                        id="invoice_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="invoice_confirm"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>

            <CustomDialog
                title="Invoice notes"
                open={invoiceNotesStatus}
                className="invoiceNotes"
                function={toggleInvoiceModal}
            >
                <h5>Add any specific information related to invoices here.</h5>
                {mapData(invoiceNotes)}
                <div className="actionWrapper">
                    <Button onClick={() => toggleInvoiceModal()}>Cancel</Button>
                    <form
                        onSubmit={formikNotesSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            type="submit"
                            label="Confirm"
                            disabled={disable}
                        />
                    </form>
                </div>
            </CustomDialog>
        </Layout>
    )
}

export default withRouter(Invoice)
